// http://tapd.oa.com/NEW_IOT/markdown_wikis/#1020393192010268057
import { getProperty } from '../util/objHandle.js'

export function queryCertificate (params = {}) {
	return {
		dataMap: {
			url: 'SLCertificateInfoRead',
			dataType: 'json',
			data: {
				action: "SLCertificateInfoRead",
				...params
			},
			dcapi: {
				fromId: 225900001,
				toId: 225900002,
				interfaceId: 126300029
			}
		},
		handlerDataFun (data, ret = {}) {
			ret['certificate'] = {
				exist: getProperty(data, 'Response.exist', false),
				info: getProperty(data, 'Response.certificate', {})
			}
		}
	}
}

export default {
	queryCertificate,
	// 处理错误码
	errorCodeMap: (data = {}) => {
		let map = {
			'-3000': '请登录'
		}

		return {
			code: data.code,
			errorMsg: map[data.code] || data.errorMsg || '系统繁忙，请稍候再试'
		}
	}
}
